// extracted by mini-css-extract-plugin
export default {"details_share":"Share_details_share__17-4s","shareBTN":"Share_shareBTN__yzs4J"};